import React, { Component } from 'react'
import { CustomLabelData } from '../apis/customLabel.api'
import customLabelService from '../services/customLabel.service'
import Card from '../components/Card'
import DownloadLink from '../components/DownloadLink'
import List, { ListItem } from '../components/List'
import csvUtil from '../utils/csv.util'
import { i18n } from '../i18n/i18n'

interface Props {
    customLabel: CustomLabelData | null
}

export default class CustomLabelInfo extends Component<Props> {
  get list (): ListItem[] {
    const { customLabel } = this.props
    if (!customLabel) return []
    const { item, printed, remainingPrintablesCount, planRemainingPrintablesCount } = customLabel
    const { hasPrintableLimit, printedCount, csvFilename, apiUrl } = customLabel
    const { csv, api } = printed
    const itemCode = item ? item.code : ''
    const csvPrints = customLabelService.printsText(csv.total, csv.printed)
    const apiPrints = customLabelService.printsText(api.total, api.printed)
    const downloadUrls = customLabelService.dataDownloadUrls(customLabel)
    const apiFilename = csvUtil.sanitizeFilename(apiUrl)
    return [
      {
        key: `${i18n('Item')}`,
        value: itemCode
      },
      {
        key: 'CSV',
        value: downloadUrls.csv && csvFilename
          ? <DownloadLink path={downloadUrls.csv} text={csvFilename}/>
          : null
      },
      {
        key: `${i18n('CSV prints')}`,
        value: csvPrints
      },
      {
        key: 'API',
        value: downloadUrls.api
          ? <DownloadLink path={downloadUrls.api} text={apiFilename}/>
          : null
      },
      {
        key: `${i18n('API prints')}`,
        value: apiPrints
      },
      {
        key: `${i18n('Total printed')}`,
        value: printedCount
      },
      {
        key: `${i18n('Remaining printables')}`,
        value: hasPrintableLimit ? remainingPrintablesCount : `${i18n('unlimited')}`
      },
      {
        key: `${i18n('Plan remaining count')}`,
        value: planRemainingPrintablesCount
      }
    ]
  }

  render () {
    return this.props.customLabel && (
            <Card>
                <List items={this.list}/>
            </Card>
    )
  }
}
